"use client";

import { c as _c } from "react/compiler-runtime";
import { animate, useInView, useMotionValue, useTransform } from "framer-motion";
import { useEffect, useRef } from "react";
interface AnimatedNumberProps {
  target: number;
  suffix?: string;
}
export function AnimatedNumber(t0) {
  const $ = _c(12);
  const {
    target,
    suffix: t1
  } = t0;
  const suffix = t1 === undefined ? "" : t1;
  const ref = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      once: true
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const inView = useInView(ref, t2);
  const motionValue = useMotionValue(0);
  const rounded = useTransform(motionValue, _temp);
  let t3;
  let t4;
  if ($[1] !== inView || $[2] !== motionValue || $[3] !== target) {
    t3 = () => {
      if (!inView) {
        return;
      }
      const controls = animate(motionValue, target, {
        duration: 1.4,
        ease: "easeOut"
      });
      return controls.stop;
    };
    t4 = [inView, motionValue, target];
    $[1] = inView;
    $[2] = motionValue;
    $[3] = target;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[6] !== rounded || $[7] !== suffix) {
    t5 = () => rounded.on("change", v_0 => {
      if (ref.current) {
        ref.current.textContent = `${v_0}${suffix}`;
      }
    });
    t6 = [rounded, suffix];
    $[6] = rounded;
    $[7] = suffix;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  if ($[10] !== suffix) {
    t7 = <span ref={ref}>0{suffix}</span>;
    $[10] = suffix;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
function _temp(v) {
  return Math.floor(v);
}